let service = function($window) {
	"ngInject";

	this.set = (key, value) => $window.localStorage.setItem(key, JSON.stringify(value));
	this.get = (key, defaultValue) => {
		var store = $window.localStorage.getItem(key);
		if (store === null) {
			return defaultValue;
		} else {
			return JSON.parse($window.localStorage.getItem(key));
		}
	}
	this.remove = (key) => $window.localStorage.removeItem(key);
	this.flush = () => $window.localStorage.clear();

};

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/session.service.js